import { render, staticRenderFns } from "./ImageRotate.vue?vue&type=template&id=35dde397&scoped=true"
import script from "./ImageRotate.vue?vue&type=script&lang=js"
export * from "./ImageRotate.vue?vue&type=script&lang=js"
import style0 from "./ImageRotate.vue?vue&type=style&index=0&id=35dde397&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35dde397",
  null
  
)

export default component.exports